import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import { secretKey } from "./data";
import Loading from "./loading.js";

const MySwal = withReactContent(Swal2);

const FreeLeads = (props) => {
  const [loading, setLoading] = useState(true);
  const [from, setFrom] = useState(
    new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1 < 10
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1) +
      "-" +
      (new Date().getDate() < 10
        ? "0" + new Date().getDate()
        : new Date().getDate())
  );
  const [to, setTo] = useState(
    new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1 < 10
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1) +
      "-" +
      (new Date().getDate() < 10
        ? "0" + new Date().getDate()
        : new Date().getDate())
  );
  const [seller, setSeller] = useState("");
  const [status, setStatus] = useState("");
  const [statuses, setStatuses] = useState([]);
  const [users, setUsers] = useState([]);

  const fetchUsersFull = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getUsersListAll", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsers(data);
        fetchStatuses();
      })
      .catch((error) => {});
  };

  const fetchStatuses = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getStatuses", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setStatuses(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchUsersFull();
  };

  useEffect(() => {
    getData();
  }, []);

  const getFree = async () => {
    if (new Date(to) < new Date(from)) {
      MySwal.fire({
        icon: "error",
        title: "Data do",
        text: 'nie może być mniejsza niż "Data od"',
      });
      return;
    }
    if (new Date(from) > new Date(to)) {
      MySwal.fire({
        icon: "error",
        title: "Data od",
        text: 'nie może być większa niż "Data do"',
      });
      return;
    }
    if (to && from && status && seller) {
    } else {
      MySwal.fire({
        icon: "error",
        title: "Uzupełnij",
        text: "wymagane pola formularza",
      });
    }

    var query = `update splitDB.leads set seller=NULL, status='zwolniony' where status='${status}' and seller='${seller}' and (DATE_FORMAT(date,'%Y-%m-%d')>='${from}' and DATE_FORMAT(date,'%Y-%m-%d')<='${to}');`;

    // console.log(
    //   `update splitDB.leads set seller=NULL, status='zwolniony' where status='${status}' and seller='${seller}' and (DATE_FORMAT(date,'%Y-%m-%d')>='${from}' and DATE_FORMAT(date,'%Y-%m-%d')<='${to}');`
    // );
    // console.log(
    //   `select * from splitDB.leads where status='${status}' and seller='${seller}' and (DATE_FORMAT(date,'%Y-%m-%d')>='${from}' and DATE_FORMAT(date,'%Y-%m-%d')<='${to}');`
    // );

    var body = {
      query: query,
    };

    await fetch("https://apisplit.ftpeople.pl/doQuery", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        getData();
      })
      .catch((error) => {});

    setFrom(
      new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1) +
        "-" +
        (new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate())
    );
    setTo(
      new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1) +
        "-" +
        (new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate())
    );
    setStatus("");
    setSeller("");
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div
            style={{
              backgroundColor: "white",
              top: "0",
              paddingTop: "5vh",
              paddingBottom: "3vh",
              paddingLeft: "2vw",
              paddingRight: "2vw",
            }}
          >
            <div
              style={{ display: "flex", justifyContent: "left", gap: "1vw" }}
            >
              <button
                className="loginButtonLogin"
                value="yes"
                style={{
                  margin: "0",
                  backgroundColor: "green",
                  borderColor: "green",
                  width: "180px",
                }}
                onClick={getData}
              >
                ODŚWIEŻ
              </button>
            </div>
          </div>

          <div style={{ display: "block", width: "50%" }}>
            <div
              style={{
                marginBottom: "1vh",
                width: "100%",
                textAlign: "left",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  width: "100%",
                }}
                className="inputBox"
              >
                <div style={{ width: "45%" }}>
                  <label
                    style={{
                      fontSize: ".6vw",
                      paddingLeft: "5px",
                    }}
                  >
                    od
                  </label>
                  <input
                    style={{ height: "3vh", width: "100%" }}
                    type="date"
                    id="name"
                    name="name"
                    value={from}
                    onChange={(e) => setFrom(e.target.value)}
                  />
                </div>
                <div style={{ width: "45%" }}>
                  <label
                    style={{
                      fontSize: ".6vw",
                      paddingLeft: "5px",
                    }}
                  >
                    do
                  </label>
                  <input
                    style={{ height: "3vh", width: "100%" }}
                    type="date"
                    id="name"
                    name="name"
                    value={to}
                    onChange={(e) => setTo(e.target.value)}
                  />
                </div>
              </div>
              <div className="inputBox">
                <div style={{ width: "45%" }}>
                  <label
                    style={{
                      fontSize: ".6vw",
                      paddingLeft: "5px",
                    }}
                  >
                    handlowiec
                  </label>
                  <select
                    style={{ height: "3vh", width: "100%" }}
                    type="date"
                    id="name"
                    name="name"
                    value={seller}
                    onChange={(e) => setSeller(e.target.value)}
                  >
                    {!seller ? (
                      <>
                        <option key="0" value="0">
                          Wybierz...
                        </option>
                      </>
                    ) : (
                      ""
                    )}
                    {users.map((e) => (
                      <option key={e.id} value={e.id}>
                        {e.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="inputBox">
                <div style={{ width: "45%" }}>
                  <label
                    style={{
                      fontSize: ".6vw",
                      paddingLeft: "5px",
                    }}
                  >
                    status
                  </label>
                  <select
                    style={{ height: "3vh", width: "100%" }}
                    type="date"
                    id="name"
                    name="name"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    {!status ? (
                      <>
                        <option key="0" value="0">
                          Wybierz...
                        </option>
                      </>
                    ) : (
                      ""
                    )}
                    {statuses.map((e) => (
                      <option key={e.name} value={e.name}>
                        {e.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div style={{ marginTop: "30px", textAlign: "left" }}>
                <button
                  style={{
                    backgroundColor: "navy",
                    border: "none",
                    color: "white",
                    textTransform: "uppercase",
                    fontWeight: "600",
                    borderRadius: "5px",
                  }}
                  id="clientsFilterButton"
                  className="paymentMenuButton"
                  onClick={getFree}
                >
                  Zwolnij
                </button>
              </div>
            </div>
          </div>

          <div
            style={{
              paddingLeft: "2vw",
              paddingBottom: "5vh",
            }}
          ></div>
        </>
      )}
    </>
  );
};

export default FreeLeads;
